// One STARS icon from the sprite in ./stars-icons.js (mountStarsIcons() must
// have run). Decorative by default; a control that is only an icon needs its
// own aria-label on the button, not on this.
const StarsIcon = ({ name, className = 'icon', ...rest }) => (
  <svg className={className} aria-hidden="true" {...rest}>
    <use href={`#i-${name}`} />
  </svg>
);

export default StarsIcon;
